module.exports = __webpack_public_path__ + "static/showreel-mobile-2ce05d0ae36613ee3fb33168164a3301.mp4";